import React, { useEffect } from 'react';
import { Navigate, Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LayoutDashboard, Package, FolderOpen, ShoppingBag, Tag, LogOut } from 'lucide-react';

const AdminLayout = () => {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <p className="text-[#A3A3A3]">Loading...</p>
      </div>
    );
  }

  if (!user || user.role !== 'admin') {
    return <Navigate to="/admin/login" replace />;
  }

  const navigation = [
    { name: 'Dashboard', href: '/admin', icon: LayoutDashboard },
    { name: 'Products', href: '/admin/products', icon: Package },
    { name: 'Categories', href: '/admin/categories', icon: FolderOpen },
    { name: 'Orders', href: '/admin/orders', icon: ShoppingBag },
    { name: 'Offers', href: '/admin/offers', icon: Tag },
  ];

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <div className="flex">
        <aside className="w-64 min-h-screen bg-[#141414] border-r border-white/10 p-6" data-testid="admin-sidebar">
          <div className="mb-8">
            <h2 className="text-2xl font-light tracking-tighter text-[#D4AF37]">Savistones</h2>
            <p className="text-xs uppercase tracking-wider text-[#A3A3A3] mt-1">Admin Panel</p>
          </div>

          <nav className="space-y-2">
            {navigation.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center space-x-3 px-4 py-3 transition-colors ${
                    isActive
                      ? 'bg-[#D4AF37] text-black'
                      : 'text-[#A3A3A3] hover:text-white hover:bg-white/5'
                  }`}
                  data-testid={`admin-nav-${item.name.toLowerCase()}`}
                >
                  <Icon size={18} />
                  <span className="text-sm uppercase tracking-wider">{item.name}</span>
                </Link>
              );
            })}
          </nav>

          <div className="mt-8 pt-8 border-t border-white/10">
            <button
              onClick={handleLogout}
              className="flex items-center space-x-3 px-4 py-3 text-[#A3A3A3] hover:text-white transition-colors w-full"
              data-testid="admin-logout-button"
            >
              <LogOut size={18} />
              <span className="text-sm uppercase tracking-wider">Logout</span>
            </button>
          </div>
        </aside>

        <main className="flex-1 p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;